// extracted by mini-css-extract-plugin
export var container = "_gv-0";
export var content = "_gv-3";
export var customerTitle = "_gv-4";
export var empty = "_gv-5";
export var gray = "_gv-6";
export var header = "_gv-7";
export var info = "_gv-8";
export var loading = "_gv-2";
export var loadingCard = "_gv-9";
export var oneLine = "_gv-a";
export var personName = "_gv-e";
export var pillContainer = "_gv-b";
export var selected = "_gv-1";
export var text = "_gv-c";
export var twoLines = "_gv-d";
export var unread = "_gv-f";
export var unreadIndicator = "_gv-g";